import i18next from "i18next";
import * as z from "zod";

import { IotError } from "@core/domain/errors/iot.error";

const brandSchema = z.literal("FallbackError").brand<"FallbackError">();

export class FallbackError extends IotError {
    readonly _brand = brandSchema;

    constructor() {
        super(i18next.t("error:core.fallbackErrorMessage"));

        Object.setPrototypeOf(this, FallbackError.prototype);
    }
}
